<template>
  <div class="d-flex mt-2 sticky-box justify-center">
    <v-btn
      outlined
      tile
      large
      class="non-text-transformation link mb-4"
      :loading="loading"
      @click="updateOfferStatus()"
    >
      {{ $t('STICKYBOX_BUTTON_UPDATE_OFFER_STATUS') }}
    </v-btn>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { REQUEST_OFFER_DATA } from '@/store/modules/offer/actions'
import { GET_OFFER_ITEM } from '@/store/modules/offer/getters'

export default {
  name: 'UpdateOfferStatusButton',
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    ...mapGetters('offer', [GET_OFFER_ITEM]),
    offerId() {
      return this[GET_OFFER_ITEM]('offerId')
    },
  },
  methods: {
    ...mapActions('offer', [REQUEST_OFFER_DATA]),
    async updateOfferStatus() {
      this.loading = true

      const res = await this[REQUEST_OFFER_DATA]({
        offerId: this.offerId,
      })

      if ('error' in res) {
        this.$emit('updateOfferError')
      }

      this.loading = false
    },
  },
}
</script>
